import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import FormAccordionCohabitaton from './form';
import {
  AccordionCohabitationVM,
  CohabitationDetailForm,
} from 'cohabitation/view-models/detail-cohabitation';

interface AccordionCohabitatonProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const AccordionCohabitatonComponent = ({
  disabled,
  isEditMode,
}: AccordionCohabitatonProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldAccordionCohabitatonChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('accordionCohabitation', {
        ...formContext.values.accordionCohabitation,
        [key]: value,
      });
    },
    [formContext.values.accordionCohabitation, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-cohabitation-content"
        id="panel-person-edit-cohabitation-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormAccordionCohabitaton
          disabled={disabled}
          isEditMode={isEditMode}
          values={formContext.values.accordionCohabitation}
          onChange={onFieldAccordionCohabitatonChange}
          errors={formContext.errors.accordionCohabitation as FormikErrors<AccordionCohabitationVM>}
          touched={
            formContext.touched.accordionCohabitation as FormikTouched<AccordionCohabitationVM>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionCohabitatonComponent.displayName = 'Accordion Cohabitation component';

const AccordionCohabitaton = memo(AccordionCohabitatonComponent);

export default AccordionCohabitaton;
